import angular from 'angular';
import Headroom from 'headroom.js';

export default angular.module('header', [])
.directive('header', header);

header.$inject = [];

function header() {
	var directive = {
		link: link,
		restrict: 'A',
		scope: {}
	};
	return directive;

	function link(scope, elem) {
		var options = {
			offset: elem[0].clientHeight,
			classes : {
				// when element is initialised
				initial : 'header',
				// when scrolling up
				pinned : 'header--pinned',
				// when scrolling down
				unpinned : 'header--unpinned',
				// when above offset
				top : 'header--top',
				// when below offset
				notTop : 'header--not-top',
				// when at bottom of scoll area
				bottom : 'header--bottom',
				// when not at bottom of scroll area
				notBottom : 'header--not-bottom'
			}
		};
		var headroom = new Headroom(elem[0], options);
		headroom.init();
	}
}



/** WEBPACK FOOTER **
 ** ./src/js/header/header.js
 **/